export default __webpack_public_path__ + "static/portfolio_gallery_16-4d0b7dd227b4cdfd7ab78ef6f7c0d161.jpg";